module.exports = __webpack_public_path__ + "static/img/ad5.d940eab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ad5.png
// module id = 5jK+
// module chunks = 30